import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './DlichosPage.css';
import dolichosLogo from '../images/dolichos-logo.png';
import reena from '../images/dolichos-reena-img.jpeg';

const varieties = [

  {
    name: 'REENA',
    image: reena,
    description: [
      'Determinate plant type with vigorous growth',
      'Early maturity with a dwarf growth habit',
      'Dark green, shiny, round, medium-long pods',
      'First picking at 48-52 days after sowing',
      'Highly remunerative to farmers',
      'Sowing time: Kharif July-August and Rabi September-November',
    ],
  },
];

export default function DlichosPage() {
  return <ProductPatternPage title="Dolichos" varieties={varieties} pageClass="dlichos-page" heroImage={dolichosLogo} />;
}
